import { orderBy } from 'lodash';

import { Clinician, IClinic, OrganizationRole } from '@customTypes/clinician';
import { IUsername } from '../types/user';

export const formatFullName = (name: IUsername, withCredential = true): string => {
  const fullName = `${name.first} ${name.last}`;

  if (name.credentials && withCredential) {
    return `${fullName}, ${name.credentials}`;
  }

  return fullName;
};

export const getClinicianName = (clinician?: Pick<Clinician, 'name'> | null, withCredential = true) => {
  if (!clinician?.name) {
    return '';
  }

  return formatFullName(clinician.name, withCredential);
};

export const getClinicianNameWithLastNameFirst = (clinician?: Clinician | null) => {
  const name = clinician?.name;

  if (!name) return '';

  const cred = name.credentials;
  let formatted = `${name.last}, ${name.first}${name.middle ? ' ' + name.middle : ''}`;

  if (cred) formatted += ', ' + cred;

  return formatted;
};

export const setOrganizationRoleFromClinic = (clinicians: Clinician[], clinicId: string): Clinician[] => {
  return clinicians.map(clinician => {
    const clinic = clinician.clinics.find(item => item.clinic_id === clinicId);
    const organizationRoles = clinic?.roles || [];

    return {
      ...clinician,
      organizational_roles: organizationRoles,
    };
  });
};

export const getOrderedClinics = (clinics: IClinic[], role: OrganizationRole): IClinic[] => {
  return orderBy(
    clinics.filter(clinic => clinic.roles.includes(role)),
    ['name'],
    ['asc'],
  );
};
